import script from "./AddMandateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMandateModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMandateModal.vue?vue&type=style&index=0&id=d5190ef4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5190ef4"]])

export default __exports__